import {
  UR_STR,
  UL_STR,
  LR_STR,
  LL_STR,
  FM_STR,
  UA_STR,
  LA_STR,
  UA_QUADRANT,
  LL_QUADRANT,
  LR_QUADRANT,
  FM_QUADRANT,
  UR_QUADRANT,
  UL_QUADRANT,
  LA_QUADRANT,
  ADMIN_ROLE,
  DOCTOR_ROLE,
  PRACTICE_ROLE,
  SUBSTRING_LIMIT,
  ADMIN_DASHBOARD_ROUTE,
  DOCTOR_DASHBOARD_ROUTE,
  TREATMENT_COLOR_ONGOING,
  TREATMENT_COLOR_TX_PLAN,
  TREATMENT_STATUS_ONGOING,
  TREATMENT_STATUS_TX_PLAN,
  PRACTICE_DASHBOARD_ROUTE,
  TREATMENT_COLOR_COMPLETED,
  TREATMENT_STATUS_COMPLETED,
  TREATMENT_COLOR_MONITORING,
  TREATMENT_STATUS_MONITORING,
} from "./constants";
import moment from "moment";
import { Badge } from "reactstrap";

const setUserInitialValues = (initalValues, user) => {
  return {
    ...initalValues,
    lastName: user?.lastName,
    firstName: user?.firstName,
  };
};

const getInitialDashboardRoute = (role) => {
  if (role === ADMIN_ROLE) {
    return ADMIN_DASHBOARD_ROUTE;
  } else if (role === DOCTOR_ROLE) {
    return DOCTOR_DASHBOARD_ROUTE;
  } else if (role === PRACTICE_ROLE) {
    return PRACTICE_DASHBOARD_ROUTE;
  }
};

const parseDate = (date) => {
  return moment(date).format("MM-DD-YYYY");
};

const parseDateString = (date) => {
  return moment(date).format("D MMM, YYYY h:mm A");
};

const formatSubString = (text) => {
  if (!text) return "";
  return `${text.substring(0, SUBSTRING_LIMIT)} ...`;
};

const createFormData = (data) => {
  const formData = new FormData();

  for (const key in data) {
    if (data.hasOwnProperty(key) && data[key] !== null) {
      if (Array.isArray(data[key]) && data[key].length > 0) {
        if (key === "treatmentCodes") {
          const updated_value = data[key].map((service) => {
            return service.value;
          });
          formData.append(key, JSON.stringify(updated_value));
        } else if (key === "toothCode") {
          const updated_value = data[key].map((service) => {
            return service.value;
          });
          formData.append(key, JSON.stringify(updated_value));
        } else if (key === "images") {
          data[key].forEach((image) => {
            formData.append(`images`, image);
          });
        } else if (key === "imageIdsToDelete") {
          data[key].forEach((id) => {
            formData.append(`imageIdsToDelete[]`, id);
          });
        } else {
          formData.append(key, JSON.stringify(data[key]));
        }
      } else if (Array.isArray(data[key]) && data[key].length === 0) {
        // Handle empty arrays
        if (key === "imageIdsToDelete") {
          // Don't send anything for empty imageIdsToDelete array
        } else if (key === "images") {
          // Don't append empty images array
        } else {
          formData.append(key, JSON.stringify(data[key]));
        }
      } else if (!Array.isArray(data[key])) {
        formData.append(key, data[key]);
      }
    }
  }

  return formData;
};

const isAdmin = (role) => {
  return role === ADMIN_ROLE;
};

const isDoctor = (role) => {
  return role === DOCTOR_ROLE;
};

// Clinical pages (Dashboard, Treatment Coordination, Patients, patient
// chart) are served under a role-specific URL prefix. Doctors get
// `/doctor/*`. Every in-app link to a clinical page must be built
// from the current user's role via this helper.
const clinicalBasePathForRole = (role) => {
  return "/doctor";
};

const showTreatmentStatus = (status) => {
  switch (status) {
    case TREATMENT_STATUS_MONITORING:
      return (
        <Badge
          color="status-monitoring"
          style={{ backgroundColor: TREATMENT_COLOR_MONITORING }}
        >
          {TREATMENT_STATUS_MONITORING}
        </Badge>
      );
    case TREATMENT_STATUS_TX_PLAN:
      return (
        <Badge
          color="status-tx-plan"
          style={{ backgroundColor: TREATMENT_COLOR_TX_PLAN }}
        >
          {TREATMENT_STATUS_TX_PLAN}
        </Badge>
      );
    case TREATMENT_STATUS_COMPLETED:
      return (
        <Badge
          color="status-completed"
          style={{ backgroundColor: TREATMENT_COLOR_COMPLETED }}
        >
          {TREATMENT_STATUS_COMPLETED}
        </Badge>
      );
    case TREATMENT_STATUS_ONGOING:
      return (
        <Badge
          color="status-ongoing"
          style={{ backgroundColor: TREATMENT_COLOR_ONGOING }}
        >
          {TREATMENT_STATUS_ONGOING}
        </Badge>
      );

    default:
      break;
  }
};

const toSentenceCase = (str) => {
  return str
    .toLowerCase()
    .split(" ")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
};

// const getTeethNoArrayTitle = (teethNoArray) => {
//   if (teethNoArray.length === 1) {
//     switch (teethNoArray[0]) {
//       case 33:
//         return UR_STR;
//       case 34:
//         return UL_STR;
//       case 35:
//         return LR_STR;
//       case 36:
//         return LL_STR;
//       case 37:
//         return FM_STR;
//       default:
//         break;
//     }
//   }

//   return teethNoArray.join(", ");
// };

const getTeethCodeArrayTitle = (toothCodes) => {
  if (toothCodes.length === 1) {
    switch (toothCodes[0]) {
      case UR_QUADRANT:
        return UR_STR;
      case UL_QUADRANT:
        return UL_STR;
      case LL_QUADRANT:
        return LL_STR;
      case LR_QUADRANT:
        return LR_STR;
      case FM_QUADRANT:
        return FM_STR;
      case UA_QUADRANT:
        return UA_STR;
      case LA_QUADRANT:
        return LA_STR;
      default:
        break;
    }
  }

  return toothCodes.join(", ");
};

// const getTeethNoTitle = (teethNo) => {
//   switch (teethNo) {
//     case 33:
//       return UR_STR;
//     case 34:
//       return UL_STR;
//     case 35:
//       return LR_STR;
//     case 36:
//       return LL_STR;
//     case 37:
//       return FM_STR;
//     default:
//       return teethNo;
//   }
// };

const getTeethCodeTitle = (teethCode) => {
  switch (teethCode) {
    case UR_QUADRANT:
      return UR_STR;
    case UL_QUADRANT:
      return UL_STR;
    case LL_QUADRANT:
      return LL_STR;
    case LR_QUADRANT:
      return LR_STR;
    case FM_QUADRANT:
      return FM_STR;
    case UA_QUADRANT:
      return UA_STR;
    case LA_QUADRANT:
      return LA_STR;
    default:
      return teethCode;
  }
};

const getTeethHashNoTitle = (toothCode) => {
  switch (toothCode) {
    case UR_QUADRANT:
      return UR_STR;
    case UL_QUADRANT:
      return UL_STR;
    case LL_QUADRANT:
      return LL_STR;
    case LR_QUADRANT:
      return LR_STR;
    case FM_QUADRANT:
      return FM_STR;
    case UA_QUADRANT:
      return UA_STR;
    case LA_QUADRANT:
      return LA_STR;
    default:
      return `#${toothCode}`;
  }
};

const mapToothCode = (code) => {
  // switch (code) {
  //   case "UR":
  //     return "1010";
  //   case "UL":
  //     return "1020";
  //   case "LR":
  //     return "1030";
  //   case "LL":
  //     return "1040";
  //   case "FM":
  //     return "1000";
  //   case "UA":
  //     return "1001";
  //   case "LA":
  //     return "1002";
  //   default:
      return String(code);
  // }
};


// eslint-disable-next-line import/no-anonymous-default-export
export default {
  // isUser,
  isAdmin,
  isDoctor,
  clinicalBasePathForRole,
  parseDate,
  createFormData,
  toSentenceCase,
  formatSubString,
  // showStatusBadge,
  parseDateString,
  getTeethCodeTitle,
  // showWishlistBadge,
  getTeethHashNoTitle,
  showTreatmentStatus,
  setUserInitialValues,
  getTeethCodeArrayTitle,
  // showOrderStatusBadge,
  getInitialDashboardRoute,
  // showPotentialBuyStatusBadge,
  mapToothCode,
};
